import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";

const videos = [
  {
    src: "https://customer-assets.emergentagent.com/job_elite-karate-3d/artifacts/3tbkrnkm_2026-06-03-153019170.mp4",
    poster:
      "https://images.unsplash.com/photo-1514050566906-8d077bae7046?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxrYXJhdGUlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODQwMzkyODl8MA&ixlib=rb-4.1.0&q=85&w=1400",
    label: "TATAMI · KATA",
    caption: "Reel 001 — antrenament Karate Shotokan",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elite-karate-3d/artifacts/4nyt9ou8_lv_0_20260517173738.mp4",
    poster:
      "https://images.unsplash.com/photo-1720731052635-c6de1beca7f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxtbWElMjBmaWdodGVyJTIwcG9ydHJhaXQlMjBoaWdoJTIwY29udHJhc3QlMjBzaGFkb3d8ZW58MHx8fHwxNzg0MDM5Mjc4fDA&ixlib=rb-4.1.0&q=85&w=1000",
    label: "SPARRING · MMA",
    caption: "Reel 002 — schimb de lovituri",
    span: "md:col-span-5",
    aspect: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elite-karate-3d/artifacts/hb4dz3cq_2026-05-29-160401800.mp4",
    poster:
      "https://images.unsplash.com/photo-1656653121526-a1458317b790?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtYXJ0aWFsJTIwYXJ0cyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NDAzOTI4OXww&ixlib=rb-4.1.0&q=85&w=1000",
    label: "DOJO · GRUPA",
    caption: "Reel 003 — sesiune de grup",
    span: "md:col-span-5",
    aspect: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elite-karate-3d/artifacts/lssn0t6r_lv_0_20260517175848.mp4",
    poster:
      "https://images.unsplash.com/photo-1637004732258-4b792ce8f474?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxrYXJhdGUlMjBibGFjayUyMGJlbHQlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NDAzOTI3OHww&ixlib=rb-4.1.0&q=85&w=1400",
    label: "DAN · TEHNICĂ",
    caption: "Reel 004 — execuție tehnică",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
  },
];

const rev = {
  hidden: { clipPath: "inset(100% 0% 0% 0%)" },
  show: {
    clipPath: "inset(0% 0% 0% 0%)",
    transition: { duration: 1.2, ease: [0.65, 0.05, 0.36, 1] },
  },
};

const VideoTile = ({ v, i }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);

  const toggle = () => {
    const el = ref.current;
    if (!el) return;
    if (el.paused) {
      el.play();
      setPlaying(true);
    } else {
      el.pause();
      setPlaying(false);
    }
  };
  const toggleMute = (e) => {
    e.stopPropagation();
    const el = ref.current;
    if (!el) return;
    el.muted = !el.muted;
    setMuted(el.muted);
  };

  return (
    <motion.figure
      className={`col-span-1 ${v.span} group`}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={rev}
    >
      <div
        className={`relative clip-frame ${v.aspect} border border-[rgba(242,235,229,0.15)] cursor-pointer bg-[#050505]`}
        onClick={toggle}
        data-testid={`video-tile-${i}`}
      >
        <video
          ref={ref}
          src={v.src}
          poster={v.poster}
          playsInline
          muted={muted}
          loop
          preload="metadata"
          className="w-full h-full object-cover photo-editorial"
        />
        {/* Gradient */}
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-[#050505]/70 via-transparent to-transparent" />
        {/* Play/Pause icon */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div
            className={`w-16 h-16 md:w-20 md:h-20 rounded-full border border-[rgba(242,235,229,0.6)] backdrop-blur-md bg-[#050505]/40 flex items-center justify-center transition-all duration-500 ${
              playing ? "opacity-0 scale-90 group-hover:opacity-100 group-hover:scale-100" : "opacity-100 scale-100"
            }`}
          >
            {playing ? (
              <Pause className="w-6 h-6 md:w-7 md:h-7 text-[#f2ebe5]" strokeWidth={1.5} />
            ) : (
              <Play className="w-6 h-6 md:w-7 md:h-7 text-[#f2ebe5] ml-1" strokeWidth={1.5} fill="#f2ebe5" />
            )}
          </div>
        </div>
        {/* Mute toggle */}
        {playing && (
          <button
            onClick={toggleMute}
            className="absolute bottom-4 right-4 w-10 h-10 rounded-full border border-[rgba(242,235,229,0.4)] bg-[#050505]/60 backdrop-blur-md flex items-center justify-center hover:bg-[#D91604] hover:border-[#D91604] transition-colors"
            data-testid={`video-mute-${i}`}
            aria-label={muted ? "unmute" : "mute"}
          >
            {muted ? (
              <VolumeX className="w-4 h-4 text-[#f2ebe5]" strokeWidth={1.5} />
            ) : (
              <Volume2 className="w-4 h-4 text-[#f2ebe5]" strokeWidth={1.5} />
            )}
          </button>
        )}
        {/* Timecode */}
        <div className="absolute bottom-4 left-4 font-jp text-xs tracking-widest text-[#f2ebe5]/70 bg-[#050505]/60 backdrop-blur px-2 py-1">
          REC · 00:0{i + 1}
        </div>
      </div>
      <figcaption className="flex items-center justify-end mt-3">
        <span className="text-xs text-[#8a8a8a]">/ 00{i + 1}</span>
      </figcaption>
    </motion.figure>
  );
};

const VideoReel = () => {
  return (
    <section
      id="video"
      className="section border-t border-[rgba(242,235,229,0.1)] bg-[#050505]"
      data-testid="video-section"
    >
      <div className="container-brutal">
        {/* Header */}
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-3">
            <span className="eyebrow">§ 05 / Reel</span>
          </div>
          <div className="col-span-12 md:col-span-9 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="section-title max-w-2xl"
            >
              Din antrenament.<br />
              <span className="font-editorial italic text-[#D91604] normal-case">în mișcare.</span>
            </motion.h2>
            <p className="text-sm text-[#8a8a8a] max-w-xs">
              Patru clipuri filmate în sală.<br />
              Apasă play — sunetul e mut inițial.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8" data-testid="video-grid">
          {videos.map((v, i) => (
            <VideoTile key={i} v={v} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoReel;
